import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { authClient } from "../lib/auth";

export function LoginPage({ onSignedIn }: { onSignedIn: () => void }) {
  const loc = useLocation();
  const next = new URLSearchParams(loc.search).get("next") || "/";
  const [mode, setMode] = useState<"in" | "up">(next.startsWith("/invite/") ? "up" : "in");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [google, setGoogle] = useState(false);

  useEffect(() => { fetch("/api/public-config").then(r => r.json()).then(c => setGoogle(!!c.google)).catch(() => {}); }, []);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true); setError("");
    const res = mode === "in"
      ? await authClient.signIn.email({ email, password })
      : await authClient.signUp.email({ email, password, name: name || email.split("@")[0] });
    setBusy(false);
    if (res.error) { setError(res.error.message || "Could not sign in"); return; }
    onSignedIn();
  };

  return (
    <div className="center">
      <form className="card" style={{ width: "min(380px, 100%)" }} onSubmit={submit}>
        <div className="brand" style={{ marginBottom: 4 }}>SUPER GANTT</div>
        <p className="muted" style={{ marginTop: 0 }}>{mode === "in" ? "Sign in to your schedules." : "Create your account."}</p>
        {mode === "up" && <label className="field">Name<input value={name} onChange={e => setName(e.target.value)} autoComplete="name" /></label>}
        <label className="field">Email<input type="email" required value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" /></label>
        <label className="field">Password<input type="password" required minLength={8} value={password} onChange={e => setPassword(e.target.value)} autoComplete={mode === "in" ? "current-password" : "new-password"} /></label>
        {error && <p className="error">{error}</p>}
        <div className="row" style={{ justifyContent: "space-between" }}>
          <button className="btn primary" disabled={busy} type="submit">{mode === "in" ? "Sign in" : "Create account"}</button>
          <button type="button" className="btn" onClick={() => { setMode(mode === "in" ? "up" : "in"); setError(""); }}>
            {mode === "in" ? "New here?" : "Have an account?"}
          </button>
        </div>
        {google && (
          <button type="button" className="btn" style={{ width: "100%", marginTop: 14 }}
            onClick={() => authClient.signIn.social({ provider: "google", callbackURL: window.location.origin + next })}>
            Continue with Google
          </button>
        )}
      </form>
    </div>
  );
}
